module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "titlePage",
    attrs: {
      "id": "tit01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page03"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "titlePageTitle"
  }, [_vm._v("L"), _c('span', {
    staticClass: "titlePageCaps2"
  }, [_vm._v("AST")]), _vm._v(" R"), _c('span', {
    staticClass: "titlePageCaps2"
  }, [_vm._v("ITUALS")])]), _vm._v(" "), _c('p', {
    staticClass: "titlePageText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("An Icelandic Novel of Secret Symbols,"), _c('br'), _vm._v(" Medieval Witchcraft, and Modern Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "titlePageAuthor"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "titlePageCaps1"
  }, [_vm._v("RSA")]), _vm._v(" S"), _c('span', {
    staticClass: "titlePageCaps1"
  }, [_vm._v("IGURDARDÓTTIR")])]), _vm._v(" "), _c('p', {
    staticClass: "titlePageAuthor1"
  }, [_vm._v("TRANSLATED FROM THE ICELANDIC BY BERNARD SCUDDER")]), _vm._v(" "), _c('p', {
    staticClass: "titlePageLogo"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "logo.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72f5c991","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title.vue
// module id = 60
// module chunks = 0